export function createStylesheetElement(href: string) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = href;
    return link;
}

export function createScriptElement(src: string) {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    return script;
}